/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  IonContent,
  IonIcon,
  IonItem,
  IonList,
  IonSlide,
  IonSlides,
  useIonPopover,
} from "@ionic/react";
import axios from "axios";
import {
  notificationsCircleOutline,
  personCircleOutline,
  powerSharp,
  closeSharp,
  pencilOutline,
  trashBinSharp,
  returnUpBackOutline,
} from "ionicons/icons";
import { config } from "process";
import React from "react";
import { useHistory } from "react-router";
import { baseUrl, requestID, removeUserSession, getToken } from "./utils";

export const PopoverList: React.FC<{
  onHide: () => void;
  onLogOut: () => void;
  onGoProfile: () => void;
  onGoNotification: ()=> void;
  
}> = ({ onHide, onLogOut , onGoProfile, onGoNotification}) => (
  <IonList>
    <IonItem  onClick={onGoNotification}  lines="full" button>
      {" "}
      <IonIcon icon={notificationsCircleOutline} slot="start" /> Notifications
    </IonItem>
    <IonItem  onClick={onGoProfile} lines="full" button>
      {" "}
      <IonIcon icon={personCircleOutline} slot="start" /> My Account{" "}
    </IonItem>
    <IonItem lines="full" onClick={onLogOut} button>
      {" "}
      <IonIcon icon={powerSharp} slot="start" /> LogOut
    </IonItem>
    <IonItem lines="none" detail={false} button onClick={onHide}>
      <IonIcon icon={closeSharp} slot="start" /> Close
    </IonItem>
  </IonList>
);
export const PopoverLists: React.FC<{
  onHide: () => void;
  onLogOut: () => void;
}> = ({ onHide, onLogOut }) => (
  <IonList>
    <IonItem lines="full" button>
      {" "}
      <IonIcon icon={pencilOutline} slot="start" /> Edit
    </IonItem>
    <IonItem lines="full" button>
      {" "}
      <IonIcon icon={trashBinSharp} slot="start" /> Delete{" "}
    </IonItem>
    <IonItem lines="full" onClick={onLogOut} button>
      {" "}
      <IonIcon icon={powerSharp} slot="start" /> LogOut
    </IonItem>
    <IonItem lines="none" detail={false} button onClick={onHide}>
      <IonIcon icon={closeSharp} slot="start" /> Close
    </IonItem>
  </IonList>
);

/*   export const config = {
      headers: { Authorization: Bearer ${getToken()} },
    }; */

export const upperCaseFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.substring(1);
};

export const slideOpts = {
  initialSlide: 1,
  speed: 400,
};

export function ucase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const getTodaysDate = () => {
  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2, "0"); // January is 0, so we add 1
  var day = String(today.getDate()).padStart(2, "0");
  var formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};



export const formattedDate = (dateString: string) => {
  // Parse the date string into a Date object
  const date = new Date(dateString);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    console.error("Invalid date provided:", dateString);
    return "Invalid Date";
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
  const year = date.getFullYear();
  
  return `${day}-${month}-${year}`;
};

export const formattedDateTime = (dateString: string) => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    // console.error("Invalid date provided:", dateString);
    return "Invalid Date";
  }

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};


export function formatCurrencyN(amount) {
  
  // Ensure the amount is a valid number
  const numericAmount = (amount);
  
  // if (isNaN(numericAmount)) {
  //   return "N/A"; // Fallback for invalid values
  // }
 if (amount === null || amount === undefined || isNaN(Number(amount))) {
    return "₦0.00";
  }

  return numericAmount.toLocaleString("en-NG", {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}


export const  formatToNaira = (amount) => {
  const numericAmount = parseFloat(amount) || 0;
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
  }).format(numericAmount);
}


export const formatCurrency =
 (value) => {
  const number = Number(value) || 0; // Safely convert to number
  return `₦${number.toLocaleString('en-NG')}`; // Use Nigerian locale for proper comma separation
};


export const  formattedDates= (dateString:string)=> {
  const date = new Date(dateString);
  
  // Get day, month, and year
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();

  // Function to add ordinal suffix to day
  const getOrdinalSuffix = (day:number) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  };

  return `${getOrdinalSuffix(day)} ${month} ${year}`;
}


// Helper function for CSV export
export const convertToCSV = (data) => {
  const headers = ['Date', 'Transaction Type', 'Deposit Amount', 'Withdrawal Amount', 'Wallet ID', 'Channel', 'Status'];
  const rows = data.map(payment => [
    formattedDates(payment.dateCreated),
    parseFloat(payment.drValue || 0) > 0 ? 'Deposit' : 'Withdrawal',
    payment.drValue || '0',
    payment.crValue || '0',
    payment.walletID,
    payment.shopID,
    'Completed'
  ]);
  
  return [headers, ...rows].map(row => row.join(',')).join('\n');
};

export const downloadCSV = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};